import { work_spaceActions } from "../actions";
import { CONTENT_GROUP_ACTION } from "../constants";
import { stageConstants } from "../constants/stage.constants";
import { buildFormDataFromObject } from "../utils/commonUtils";
import { reorderArray } from "../utils/reorderArray";
import stageHasTrackedCards from "../utils/stageHasTrackedCards";

/**
 * 
 * @param {Object} result - The result object from the drag and drop event.
 * @param {Array} stages - The array of stage objects.
 * @param {Function} dispatch - The Redux dispatch function.
 * @param {string} workspace_id - The ID of the workspace.
 */
export default function handleDragEndCard({
    result,
    stages,
    dispatch,
    workspace_id
}) {
    const { destination, source, type, draggableId } = result;
    const alertMessage = `You have a card currently being time-tracked.`;

    if (!destination) return;

    const updateServer = (newArray, card_drag_id, source_stage_id, destination_stage_id) => {
        const updatedStageIds = newArray.map((stage) => ({
            id: stage.id,
            items: stage.items.map((card) => ({
                id: card.id
            }))
        }))

        let formData = new FormData();
        buildFormDataFromObject(formData, updatedStageIds, "sort");
        dispatch(work_spaceActions.updateSortContentGroupWorkSpace(formData, workspace_id, [card_drag_id], source_stage_id, destination_stage_id, type));
    }

    // Stage Sort
    if(type === 'COLUMN'){
        if (!destination || source.index === destination.index) return;

        const card_drag_id = draggableId.replace(/column-/g,'')

        // Reorder columns locally for the API call
        const updatedStages = reorderArray(stages, source.index, destination.index).map((stage, idx) => ({
            ...stage,
            index: idx
        }));

        // Update Redux here
        dispatch({
            type: stageConstants.SET_STAGES,
            payload: {
                data: {
                    data: updatedStages
                }
            }
        });

        // API call to update the order of cards
        updateServer(updatedStages, card_drag_id, "", "");
    } else if (type === 'CARD') {
        const sourceStage = stages.find(stage => stage.id.toString() === source.droppableId.toString());
        const destStage = stages.find(stage => stage.id.toString() === destination.droppableId.toString());

        if (!sourceStage || !destStage) return;

        const hasTrackedCards = stageHasTrackedCards(destStage);

        if (destStage?.enable_timestamp && hasTrackedCards.result && type === 'CARD' && sourceStage.id !== destStage.id) {
            dispatch({ type: CONTENT_GROUP_ACTION.OPEN_INVALID_STAGE_MODAL, payload:  { cards: hasTrackedCards.cards } });
            return;
        }

        const card_drag_id = draggableId.replace(/card-/g,'')

        if (!sourceStage || !destStage) return;

        // Clone cards arrays
        const sourceCards = Array.from(sourceStage.items);
        const destCards = sourceStage === destStage ? sourceCards : Array.from(destStage.items);

        // Remove card from source
        const [movedCard] = sourceCards.splice(source.index, 1);
        const updatedMovedCard = {
            ...movedCard,
            stage_id: destStage.id,
            index: destination.index
        };

        // Insert card into destination
        destCards.splice(destination.index, 0, updatedMovedCard);

        // Update stages with new cards arrays
        const updatedStages = stages.map(stage => {
            if (stage.id === sourceStage.id) {
                return {
                    ...stage,
                    items: stage === destStage ? destCards : sourceCards
                };
            }
            if (stage.id === destStage.id) {
                return {
                    ...stage,
                    items: destCards
                };
            }
            return stage;
        });

        // Update Redux
        dispatch({
            type: stageConstants.SET_STAGES,
            payload: {
                data: {
                    data: updatedStages
                }
            }
        });

        // Optionally, make API call to persist card move here
        updateServer(updatedStages, card_drag_id, sourceStage.id, destStage.id);
    }
}